// Maps desktop OCR preparation onto one continuously moving progress value.
// The model downloads report real byte progress and cover 0–65%. Engine
// startup (WASM fetch/compile, model parsing inside the worker) exposes no
// progress signal, so the bar eases toward 97% until the engine is ready —
// each step covers a fixed fraction of the remaining distance, so it keeps
// moving but never finishes on its own.
const DOWNLOAD_PROGRESS_SHARE = 65;
const STARTING_PROGRESS_CEILING = 97;
const STARTING_EASE_STEP = 0.06;

export const getOcrProgressTarget = (preparation, currentPercent = 0) => {
    if (!preparation) return 0;

    if (preparation.phase === 'downloading') {
        const fraction = preparation.total
            ? Math.min(1, preparation.loaded / preparation.total)
            : 0;
        return Math.max(currentPercent, fraction * DOWNLOAD_PROGRESS_SHARE);
    }

    if (preparation.phase === 'starting') {
        return Math.min(
            STARTING_PROGRESS_CEILING,
            currentPercent +
                (STARTING_PROGRESS_CEILING - currentPercent) *
                    STARTING_EASE_STEP
        );
    }

    if (preparation.phase === 'ready') return 100;
    return 0;
};
